/**
 * @requires HBS
 */
(function() {
	/**
	 * @exports APP.main
	 */
	let module = {};

	module.outsideClick = (event) => {
		let notelem = document.querySelectorAll('.js-primary-nav__dropdown');
		let clickedOut = true, i, len = notelem.length;

		let clickedItems = document.querySelectorAll('.js-been-clicked');
		clickedItems.forEach((item) => {
			item.classList.remove('js-been-clicked');
		});

		for (i = 0;i < len;i++)  {
			if (event.target === notelem[i] || notelem[i].contains(event.target)) {
				clickedOut = false;
			}
		}
		return clickedOut;
	}

	module.setupBalanceText = () => {
		balanceText();
	}


	// Gets the lat/long from the browser
	function getLocation() {
		document.getElementById("js-locate-me").innerText = "";
		document.getElementById("js-locate-me").classList.remove("btn--spinning-hidden");

		var options = {
			enableHighAccuracy: false,
			timeout: 5000,
			maximumAge: 1000 * 60 * 60 // 1 hour
		};

		if (navigator.geolocation) {
			navigator.geolocation.getCurrentPosition(handlePosition, showError, options);
		} else {
			console.log("Geolocation is not supported by this browser.");
		}
	}

	function supportChatButtonTrigger(){
		let startChatButton = document.querySelector('.js-start-chat');

		startChatButton.addEventListener('click', (e) => {
			e.preventDefault();
			
		})
	}

	// Converts the lat/long into a zip code via Google API reverse geocoding
	// and then opens the ATM finder in a new tab
	function handlePosition(position) {
		var lat = position.coords.latitude;
		var long = position.coords.longitude;
		var apiUrl = "/wp-json/pfcu/v1/geocode/" + lat + "/" + long;
		
		fetch(apiUrl)
			.then(response => response.json())
			.then(data => {
				let parts = data.results[0].address_components;

				parts.forEach(part => {
					if (part.types.includes("postal_code")) {
						var foundZipCode = part.long_name;
						
						document.getElementById('js-location-input').value = foundZipCode;
						document.getElementById('js-submit').click();
					}
				})
			})
			.catch(err => console.warn(err.message));
	}

	// Prints out errors to the console if the lat/long can't be retrieved
	function showError(error) {
		switch(error.code) {
			case error.PERMISSION_DENIED:
				console.log("User denied the request for Geolocation.");
				break;
			case error.POSITION_UNAVAILABLE:
				console.log("Location information is unavailable.");
				break;
			case error.TIMEOUT:
				console.log("The request to get user location timed out.");
				break;
			case error.UNKNOWN_ERROR:
				console.log("An unknown error occurred.");
				break;
		}
	}

	// Gets the entered zip code from the input field and opens the ATM finder in a new tab
	function submitZipCode(e) {
		e.preventDefault();

		var inputField = document.getElementById('js-location-input');
		var zipCode = inputField.value;

		document.getElementById('js-error').classList.add('d-none');
		inputField.classList.remove('is-invalid');

		if (zipCode.length == 0) {
			var errorMessage = "Please enter a U.S. zip code";
			validationError(errorMessage);
		} else {
			var zipCodeTest = validateZip(zipCode);

			if (zipCodeTest) {
				var redirectUrl = "https://co-opcreditunions.org/locator/search-results/?loctype=AS&zip=" + zipCode;
				zipCodeRedirect(redirectUrl);
			} else {
				var errorMessage = "Please enter a valid U.S. zip code";
				validationError(errorMessage);
				inputField.value = '';
			}
		}

		document.getElementById("js-locate-me").classList.add("btn--spinning-hidden");
		document.getElementById("js-locate-me").innerText = "Use My Location";
	}

	function validationError(str) {
		var errorCopy = document.getElementById('js-error');
		var inputField = document.getElementById('js-location-input');

		errorCopy.classList.remove('d-none');
		errorCopy.innerText = str;
		inputField.classList.add('is-invalid');
		inputField.focus();
	}

	// Validates that a string is the format of a US zip code
	function validateZip(str) {
		return /^\d{5}(-\d{4})?$/.test(str);
	}

	// Opens a Url in a new tab
	function zipCodeRedirect(str) {
		window.open(str, '_blank');
	}

	module.isTouchDevice = () => {
		return window.matchMedia("(pointer: coarse)").matches;
	}

	module.setStuckState = () => {
		let mainHeader = document.querySelector('.js-sticky-header');
		document.addEventListener('scroll', () => {
			if(window.scrollY > 0 && !mainHeader.classList.contains('state-stuck')) {
				mainHeader.classList.add('state-stuck');
			}
			if(window.scrollY === 0 && mainHeader.classList.contains('state-stuck')) {
				mainHeader.classList.remove('state-stuck');
			}
		});
	}

	module.setupNavigation = () => {
		let dropdownSubnavLinks = document.querySelectorAll('.js-submenu-link');
		let dropdownSubnavChevrons = document.querySelectorAll('.submenu-nav__chevron');
		let submenus = document.querySelectorAll('.js-submenu-content');
		let primaryLinks = document.querySelectorAll('.primary-nav__link[data-id]');
		let primaryLinkChevrons = document.querySelectorAll('.primary-nav__chevron');
		let primaryLinkDropdowns = document.querySelectorAll('.js-primary-nav__dropdown');
		let backButton = document.querySelectorAll('.js-back');
		let backDeepButton = document.querySelectorAll('.js-back-deep');
		let menuContainer = document.querySelector('.js-menu-container');
		let mobileMenuTrigger = document.querySelector('.js-mobile-menu-trigger');
		let submenuNavItems = document.querySelectorAll('.submenu-nav__item');

		let toggleMenu = (event) => {
			if(menuContainer) {
				if(menuContainer.classList.contains('state-visible')) {
					menuContainer.classList.remove('state-visible');
					document.body.classList.remove('state-fixed');
					event.target.classList.remove('state-visible');
				} else {
					menuContainer.classList.add('state-visible');
					document.body.classList.add('state-fixed');
					event.target.classList.add('state-visible');
				}
			}
		};

		let menuClick = (event) => {
			let submenuLink = event.target;
			let theID = submenuLink.getAttribute('data-id');
			let targetedContainer = document.getElementById(theID);
			dropdownSubnavLinks.forEach((subLink) => {
				subLink.classList.remove('state-active');
			})
			submenuLink.classList.add('state-active');
			submenus.forEach((submenuBlock) => {
				submenuBlock.classList.remove('state-visible');
			});
			targetedContainer.classList.add('state-visible');
			let parent = event.target.closest('.js-primary-nav__dropdown');
			let contentCol = parent.querySelector('.js-content-col');
			contentCol.classList.add('state-visible');
		};


		let resetLinks = () => {
			primaryLinkDropdowns.forEach((dropdown) => {
				let submenuLinks = dropdown.querySelectorAll('.submenu-nav__link');
				let contentBlocks = dropdown.querySelectorAll('.js-submenu-content');
				dropdown.classList.remove('state-visible');
				submenuLinks.forEach((link) => {
					link.classList.remove('state-active');
					link.classList.remove('js-been-clicked')
				});
				contentBlocks.forEach((block) => {
					block.classList.remove('state-visible');
				});
			});
		}

		let clickOutside = (event) => {
			if (module.outsideClick(event)) {
				resetLinks();
			}
		};

		let mouseEnterFunction = (event) => {
			if(module.isTouchDevice() && window.innerWidth > 767) {
				let links = document.querySelectorAll('.primary-nav__link');
				if (!event.target.classList.contains('js-been-clicked')) {
					event.preventDefault();
					links.forEach((link) => {
						link.classList.remove('js-been-clicked');
					});
					event.target.classList.add('js-been-clicked');
				}
			}

			resetLinks();
			let theID = event.currentTarget.getAttribute('data-id');
			if(theID) {
				let targetedMenu = document.getElementById(theID);
				let firstLink = targetedMenu.querySelectorAll('.submenu-nav__link');
				let targetedMenuContent = targetedMenu.querySelectorAll('.js-submenu-content');
				targetedMenu.classList.add('state-visible');
				firstLink[0].classList.add('state-active');
				targetedMenuContent[0].classList.add('state-visible');
			}
		};

		let dropdownMouseEnter = (event) => {
			if(module.isTouchDevice() && window.innerWidth > 767) {
				let links = document.querySelectorAll('.submenu-nav__link.js-submenu-link');
				if(!event.target.classList.contains('js-been-clicked')) {
					links.forEach((link) => {
						link.classList.remove('js-been-clicked');
					});
					event.preventDefault();
					event.target.classList.add('js-been-clicked');
				}
			}


			let dropdownLink = event.target;
			dropdownSubnavLinks.forEach((dLink) => {
				dLink.classList.remove('state-active')
			});
			dropdownLink.classList.add('state-active');
			let theID = dropdownLink.getAttribute('data-id');
			let targetedMenu = document.getElementById(theID);
			submenus.forEach((submenu) => {
				submenu.classList.remove('state-visible');
			});
			targetedMenu.classList.add('state-visible');
		};

		let slideMenus = (event) => {
			let theID = event.target.getAttribute('data-id');
			let targetElement = document.getElementById(theID);
			targetElement.classList.add('state-visible');
			event.preventDefault();
		};

		let backToMainMenu = (event) => {
			event.currentTarget.closest('.js-primary-nav__dropdown').classList.remove('state-visible');
		}

		let backToSubMenu = (event) => {
			let contentCol = event.currentTarget.parentElement;
			contentCol.classList.remove('state-visible');
		}

		let setupMobile = () => {
			window.removeEventListener('click', clickOutside, false);
			dropdownSubnavLinks.forEach((dropdownLink) => {
				dropdownLink.removeEventListener('mouseenter', dropdownMouseEnter, false);
			});
			primaryLinks.forEach((link) => {
				link.removeEventListener('mouseenter', mouseEnterFunction, false);
			});
			primaryLinkDropdowns.forEach((dropdown) => {
				dropdown.removeEventListener('mouseleave', clickOutside, false);
			});

			mobileMenuTrigger.addEventListener('click', toggleMenu, false);

			dropdownSubnavChevrons.forEach((chevron) => {
				chevron.addEventListener('click', menuClick, false)
			});

			primaryLinkChevrons.forEach((chevron) => {
				if(chevron.getAttribute('data-id')) {
					chevron.addEventListener('click', slideMenus, false);
				}
			});

			primaryLinkDropdowns.forEach((dropdown) => {
				dropdown.classList.remove('state-visible');
			})

			submenuNavItems.forEach((item) => {
				item.querySelector('a').classList.remove('state-active');
			});

			primaryLinks.forEach((link) => {
				link.removeEventListener('touchstart', mouseEnterFunction, false);
			});

			backButton.forEach((bb) => {
				bb.addEventListener('click', backToMainMenu, false);
			});

			backDeepButton.forEach((bdb) => {
				bdb.addEventListener('click', backToSubMenu, false);
			});
		};

		let setupDesktop = () => {
			//undo mobile stuff

			let contentColumns = document.querySelectorAll('.js-content-col');
			mobileMenuTrigger.removeEventListener('click', toggleMenu, false);
			dropdownSubnavChevrons.forEach((chevron) => {
				chevron.removeEventListener('click', menuClick, false);
			});
			primaryLinkChevrons.forEach((chevron) => {
				if(chevron.getAttribute('data-id')) {
					chevron.removeEventListener('click', slideMenus, false);
				}
			});

			backButton.forEach((bb) => {
				bb.removeEventListener('click', backToMainMenu, false);
			});

			backDeepButton.forEach((bdb) => {
				bdb.removeEventListener('click', backToSubMenu, false);
			});
			//END Undo mobile stuff

			primaryLinkDropdowns.forEach((dropdown) => {
				dropdown.addEventListener('mouseleave', clickOutside, false);
			});

			window.addEventListener('click', clickOutside, false);

			if(!module.isTouchDevice()) {
				primaryLinks.forEach((link) => {
					link.addEventListener('mouseenter', mouseEnterFunction, false);
				});
			} else {
				primaryLinks.forEach((link) => {
					link.addEventListener('touchstart', mouseEnterFunction, false);
				});
			}
			if(!module.isTouchDevice()) {
				dropdownSubnavLinks.forEach((dropdownLink) => {
					dropdownLink.addEventListener('mouseenter', dropdownMouseEnter, false);
				});
			} else {
				dropdownSubnavLinks.forEach((dropdownLink) => {
					dropdownLink.addEventListener('touchstart', dropdownMouseEnter, false);
				});
			}
		};

		enquire.register("screen and (max-width: 767px)", {
			match : function() {
				setupMobile();
			},
			unmatch : function() {
				setupDesktop();
			},
			setup : function() {
				setupDesktop();
			}
		});
	}

	module.chatButton = () => {
		let buttonParent = document.getElementsByClassName('js-start-chat');

		for (var i = 0; i < buttonParent.length; i++) {
			buttonParent[i].addEventListener('click', function(e) {
				e.preventDefault();

				LiveChatWidget.call("maximize");

			})
		}
	}

	module.atmLocatorLinks = () => {
		let locatorLinks = document.querySelectorAll('.js-atm-locator');

		locatorLinks.forEach((link) => {
			link.addEventListener('click', (e) => {
				e.preventDefault();
				let linkID = link.getAttribute('data-modal-id');
				MicroModal.show(linkID);
			});
		});
	}


	module.screenShareButton = () => {
		let footerNav = document.getElementById('js-footer-nav');
		let listItems = footerNav.getElementsByTagName('li');
		let shareButton;

		for (let i = 0; i < listItems.length; i++) {
			if (listItems[i].innerText.includes('Screen Share')) {
				shareButton = listItems[i].getElementsByTagName('a');

				shareButton[0].addEventListener('click', function(e) {
					e.preventDefault;
					MicroModal.show('shareLauncher');
				})
			}
		}

		let modalButton = document.getElementById('js-launch-share');
		
		modalButton.addEventListener('click', function() {
			MicroModal.close('shareLauncher');
			cobrowseStart();			
		})
	}

	/**
	 * Global init code for the whole application
	 */
	module.init = function() {
		if(module.isTouchDevice()) {
			document.body.classList.add('touch');
		} else {
			document.body.classList.add('no-touch');
		}
		module.setupNavigation();
		module.setStuckState();
		module.chatButton();
		module.screenShareButton();
		module.atmLocatorLinks();
		module.setupBalanceText();
		// module.atmFormSubmission();
		MicroModal.init();
		

		document.getElementById('js-locate-me').addEventListener('click', getLocation);
    	document.getElementById('js-location-form').addEventListener('submit', submitZipCode);
	};

	/**
	 * Initialize the app and run the bootstrapper
	 */

	function docReady(fn) {
		// see if DOM is already available
		if (document.readyState === "complete" || document.readyState === "interactive") {
			// call on next available tick
			setTimeout(fn, 1);
		} else {
			document.addEventListener("DOMContentLoaded", fn);
		}
	}

	docReady(function() {
		module.init();
		HBS.initPage();
		// DOM is loaded and ready for manipulation here
	});

	HBS.namespace('PFC.main', module);
}());
